/* eslint-disable max-lines-per-function */
import {
   ActionBar,
   ButtonVariant,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { DocumentTemplateFormController } from '~libs.desktop.shared.document-template';
import {
   MedicalDocumentationPasswordDetailsShowModalInterceptor,
   MedicalDocumentationShareForm,
} from '~libs.desktop.shared.medical-documentation';

import { usePushBackToVisit } from '../../../shared/hooks/usePushBackToVisit';
import { translationKeys } from '../translations';

import { VisitDocumentApproveActionInterceptor } from './interceptors/VisitDocumentApproveActionInterceptor';
import { VisitDocumentShareActionEventInterceptor } from './interceptors/VisitDocumentShareActionEventInterceptor';

export type VisitDocumentApproveAndShareActionProps = Pick<
   DocumentTemplateFormController,
   'handleSubmit' | 'trigger' | 'getValue' | 'markPristine'
> &
   Readonly<{
      patientId: number;
      visitId: number;
      printTemplateId: number;
   }>;

export const VisitDocumentApproveAndShareAction = (props: VisitDocumentApproveAndShareActionProps): JSX.Element => {
   const pushBackToVisit = usePushBackToVisit(props.visitId);

   return (
      <ValidateFormEventInterceptor trigger={props.trigger}>
         <ShowModalEventInterceptor
            testId={'sharePatientDocumentation'}
            title={translationKeys.shareRecordsWithPatient}
            content={({ resolve, reject }) => (
               <MedicalDocumentationShareForm patientId={props.patientId}>
                  {({ trigger, handleSubmit: handleMedicalDocumentationShareSubmit }) => {
                     return (
                        <>
                           <ValidateFormEventInterceptor trigger={trigger}>
                              <VisitDocumentApproveActionInterceptor
                                 patientId={props.patientId}
                                 visitId={props.visitId}
                                 printTemplateId={props.printTemplateId}
                                 handleSubmit={props.handleSubmit}
                                 markPristine={props.markPristine}
                              >
                                 <VisitDocumentShareActionEventInterceptor
                                    visitId={props.visitId}
                                    printTemplateId={props.printTemplateId}
                                    documentTemplateValues={props.getValue('documentTemplateValues')}
                                    handleMedicalDocumentationShareSubmit={handleMedicalDocumentationShareSubmit}
                                 >
                                    {({ filePassword }) => (
                                       <MedicalDocumentationPasswordDetailsShowModalInterceptor
                                          filePassword={filePassword}
                                          title={translationKeys.createdAndSentPatientRecords}
                                          successMessage={
                                             translationKeys.sentDocumentationToPatientAndSmsMessageWithPassword
                                          }
                                       >
                                          <ModalConfirmButton label={translationKeys.send} onClick={resolve} />
                                       </MedicalDocumentationPasswordDetailsShowModalInterceptor>
                                    )}
                                 </VisitDocumentShareActionEventInterceptor>
                              </VisitDocumentApproveActionInterceptor>
                           </ValidateFormEventInterceptor>

                           <ModalCancelButton label={translationKeys.back} onClick={reject} />
                           <ModalCloseButton onClick={reject} />
                        </>
                     );
                  }}
               </MedicalDocumentationShareForm>
            )}
            modalWidth={ModalWidth.NORMAL}
            shouldShowModal
            footerItemsHidden
         >
            <ActionBar.PrimaryButton
               variant={ButtonVariant.SECONDARY}
               onClick={pushBackToVisit}
               label={translationKeys.confirmAndShare}
               testId={'confirmAndShare'}
            />
         </ShowModalEventInterceptor>
      </ValidateFormEventInterceptor>
   );
};
